export const TAG_GROUP_RELATIVE_PATH_YOGA_CLASS_LEVEL = 'yoga-class-level'
export const TAG_GROUP_RELATIVE_PATH_TAGS = 'tags'
export const TAG_GROUP_RELATIVE_PATH_YOGA_CLASS_STYLE = 'yoga-class-style'
export const TAG_GROUP_RELATIVE_PATH_YOGA_CLASS_ANATOMICAL_FOCUS = 'yoga-class-anatomical-focus'
export const TAG_GROUP_RELATIVE_PATH_SEO_TAGS = 'seo-tags'
export const TAG_GROUP_RELATIVE_PATH_YOGA_CLASS_TIME_OF_DAY = 'yoga-class-time-of-day'
export const TAG_GROUP_RELATIVE_PATH_COURSE_CATEGORY = 'course-category'
export const TAG_GROUP_RELATIVE_PATH_USER_GOALS = 'user-goals'
export const TAG_GROUP_RELATIVE_PATH_POSE_CATEGORY = 'pose-category'
export const TAG_GROUP_RELATIVE_PATH_MEDITATION_FOCUS = 'meditation-focus'
export const TAG_GROUP_RELATIVE_PATH_YOGA_CLASS_ENERGETIC_EFFECT = 'yoga-class-energetic-effect'
export const TAG_GROUP_RELATIVE_PATH_CHANNELS = 'channels'
export const TAG_GROUP_RELATIVE_PATH_YOGA_CLASS_PROPS = 'yoga-class-props'
export const TAG_GROUP_RELATIVE_PATH_YOGA_CLASS_PHYSICAL_FOCUS = 'yoga-class-physical-focus'
export const TAG_GROUP_RELATIVE_PATH_YOGA_CLASS_WELLBEING = 'yoga-class-wellbeing'
export const TAG_GROUP_RELATIVE_PATH_YOGA_CLASS_MOVEMENT = 'yoga-class-movement'
export const TAG_GROUP_RELATIVE_PATH_YOGA_CLASS_SECONDARY_STYLE = 'yoga-class-secondary-style'
export const TAG_GROUP_RELATIVE_PATH_YOGA_CLASS_INTENSITY = 'yoga-class-intensity'

// Most of tag groups generated by migration script, except two that are created manually. These tags marked with "MANUAL_" prefix
export const MANUAL_TAG_GROUP_RELATIVE_PATH_COURSE_MODULE_TYPE = 'course-module-group'
export const MANUAL_TAG_GROUP_RELATIVE_PATH_COURSE_CONSUMPTION_TYPE = 'consumption-type-group'
export const MANUAL_TAG_GROUP_RELATIVE_PATH_PRACTICE_TYPE = 'practice-type-group'
